import React, { useState } from "react"
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import SearchBar from '../SearchBar/SearchBar';
import { Link, useLocation } from 'react-router-dom';

import "./NavBar.css"

const pages = [
    { 'title': 'Home', 'path': '' },
    { 'title': 'Consensus Rankings', 'path': 'consensus-rankings' },
    { 'title': 'Mocks and Rankings', 'path': 'mocks-and-rankings' },
    { 'title': 'Drafts', 'path': 'draft-order' },
    { 'title': 'Draft Prospects', 'path': 'players' },
    { 'title': 'Blog', 'path': 'blog' },
    { 'title': 'Player Comparison', 'path': 'player-comparison' }
];

function NavBar() {
    const [anchorElNav, setAnchorElNav] = useState("");
    const location = useLocation();

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };


    return (
        <AppBar position="sticky" elevation={0} sx={{
            backgroundColor: '#0b0d10'
        }} className="nav-bar">
            <Container maxWidth={false}>
                <Toolbar disableGutters sx={{ minHeight: { xs: 56, md: 60 } }}>
                    <Link to={"/"} style={{ display: 'flex', alignItems: 'center' }}>
                        <Box
                            component="img"
                            sx={{
                                display: { xs: 'flex', md: 'flex' },
                                height: 38,
                                width: 'auto',
                                maxHeight: { xs: 36, md: 40 },
                                position: "relative"
                            }}
                            alt="Hockey Pipeline"
                            src="/logo@4x.png"
                        />
                    </Link>

                    <Box sx={{ flexGrow: 300, justifyContent: "center", display: { s: 'flex', md: 'none' } }}>
                        <SearchBar />
                    </Box>
                    <Box sx={{ flexGrow: 1, justifyContent: "right", display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            {pages.map((page) => (
                                <Link to={"/" + page.path}>
                                    <MenuItem
                                        key={page.title}
                                        onClick={handleCloseNavMenu}
                                        className={location.pathname === "/" + page.path ? "active" : ""}
                                    >
                                        <Typography textAlign="center">{page.title}</Typography>
                                    </MenuItem>
                                </Link>
                            ))}
                        </Menu>
                    </Box>



                    <Box sx={{ flexGrow: 1, justifyContent: "left", display: { xs: 'none', md: 'flex' } }} className="nav-btns">
                        {pages.map((page) => (
                            <Link to={"/" + page.path} key={page.path}>
                                <Button
                                    onClick={handleCloseNavMenu}
                                    disableRipple
                                    sx={{ display: 'block' }}
                                    className={location.pathname === "/" + page.path ? "active" : ""}
                                >
                                    {page.title}
                                </Button>
                            </Link>
                        ))}
                    </Box>

                    <Box sx={{ flexGrow: { md: 0.5, lg: 1.5, xl: 0.25 }, justifyContent: "right", display: { xs: 'none', md: 'flex' } }}>
                        <SearchBar />
                    </Box>

                </Toolbar>
            </Container>
        </AppBar>
    );
}
export default NavBar;